import { IIntroductionLinkProps } from '../components/home-components/instruction-link';

export const homePageInstructionsWeb1 = [
  {
    name: 'CREATE PRIVATE (JOURNAL) NOTES',
    pdfUrl: '/documents/2026_03_29/Create Private Journal Note (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE CLOSED GROUP NOTES',
    pdfUrl: '/documents/2026_03_29/Create Closed Group Notes (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE PUBLIC GROUP NOTES',
    pdfUrl: '/documents/2026_03_29/Create Public Group Notes (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE HIGHLIGHTS, ADDING IMAGE/TEXT',
    pdfUrl: '/documents/2026_03_29/Create Highlights (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE CLOSED OR PUBLIC GROUPS',
    pdfUrl: '/documents/2026_03_29/Create Closed or Public Groups (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
];
